import con from '../../../connection';
var path = '/organizations';
var organizations = function (url) { return function () { return ({
    get: function () { return (
    // 組織一覧取得
    con.get("" + url + path, {})); },
}); }; };
export default organizations;
